import { combineReducers } from 'redux';

import { realtorsFiltersReducer } from './filters';
import { realtorsListingReducer } from './listing';

export const realtors = combineReducers({
  listing: realtorsListingReducer,
  filters: realtorsFiltersReducer,
});
